import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'billto_bp': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'billto_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname
  },
  'posting_date': {
    title: '上帐日期',
    type: 'date',
    equation: all
  },
  'zy': {
    title: '摘要',
    type: 'input',
    equation: all
  },
  'goods_amount': {
    title: '金额'
  }
}



// WEBPACK FOOTER //
// ./src/views/dealer-manage/config/costReport.js